export default {
  de: {
    settings: 'Einstellungen',
  },
};
